var _defs, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRibbon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    fillRule: "evenodd",
    stroke: "black",
    strokeWidth: 0.501,
    strokeLinejoin: "bevel",
    strokeMiterlimit: 10,
    fontFamily: "Times New Roman",
    fontSize: 16,
    style: {
      fontVariantLigatures: "none"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    width: "76.771pt",
    height: "82.5pt",
    viewBox: "1051.24 -488.875 76.771 82.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1",
    transform: "scale(1 -1)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "\\xDD\\u0161\\u0164\\u015F 1",
    transform: "scale(1 -1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer 3",
    transform: "scale(1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    stroke: "#505050",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1118.54,463.634 C 1118.01,465.916 1116.25,467.588 1114.13,468.12 C 1115.1,470.059 1114.99,472.457 1113.63,474.336 C 1112.32,476.157 1110.17,477.021 1108.09,476.793 C 1108.16,478.864 1107.16,480.913 1105.27,482.091 C 1103.29,483.334 1100.86,483.272 1098.98,482.146 C 1098.3,484.202 1096.52,485.819 1094.24,486.189 C 1092.02,486.547 1089.89,485.643 1088.58,484.009 C 1087.16,485.52 1085.01,486.262 1082.84,485.764 C 1080.56,485.24 1078.89,483.48 1078.36,481.355 C 1076.42,482.324 1074.02,482.213 1072.14,480.857 C 1070.32,479.543 1069.46,477.4 1069.68,475.317 C 1067.61,475.383 1065.56,474.384 1064.39,472.501 C 1063.14,470.517 1063.2,468.09 1064.33,466.211 C 1062.28,465.525 1060.66,463.752 1060.29,461.463 C 1059.93,459.247 1060.83,457.121 1062.47,455.809 C 1060.96,454.392 1060.21,452.236 1060.71,450.072 C 1061.24,447.79 1063,446.117 1065.12,445.585 C 1064.15,443.646 1064.26,441.249 1065.62,439.369 C 1066.93,437.548 1069.08,436.685 1071.16,436.912 C 1071.09,434.842 1072.09,432.793 1073.98,431.614 C 1075.96,430.372 1078.39,430.433 1080.27,431.56 C 1080.95,429.503 1082.73,427.887 1085.01,427.517 C 1087.23,427.158 1089.36,428.062 1090.67,429.696 C 1092.09,428.186 1094.24,427.443 1096.41,427.941 C 1098.69,428.466 1100.36,430.225 1100.89,432.351 C 1102.83,431.381 1105.23,431.492 1107.11,432.849 C 1108.93,434.163 1109.79,436.305 1109.57,438.388 C 1111.64,438.322 1113.68,439.322 1114.86,441.204 C 1116.11,443.189 1116.04,445.615 1114.92,447.495 C 1116.97,448.18 1118.59,449.954 1118.96,452.242 C 1119.32,454.459 1118.42,456.584 1116.78,457.896 C 1118.29,459.314 1119.03,461.47 1118.54,463.634 M 1094.36,435.66 C 1082.67,432.972 1071.02,440.269 1068.33,451.958 C 1065.65,463.646 1072.94,475.3 1084.63,477.987 C 1096.32,480.675 1107.97,473.378 1110.66,461.689 C 1113.35,450.001 1106.05,438.347 1094.36,435.66 Z",
    markerStart: "none",
    markerEnd: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1122.43,472.135 L 1126.76,471.699",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1114.43,483.428 L 1116.2,487.625",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1120.99,479.261 L 1126.44,483.713",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1056.82,472.135 L 1052.49,471.699",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1064.82,483.428 L 1063.05,487.625",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1058.26,479.261 L 1052.81,483.713",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1091.4,429.044 L 1101.9,407.625 L 1108.37,418.204 L 1120.7,416.84 L 1110.12,438.409",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1110.5,424.006 L 1106.38,432.405",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1098.25,428.711 L 1102.48,420.073",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1087.12,427.555 L 1077.34,407.625 L 1070.88,418.204 L 1058.55,416.84 L 1068.54,437.215",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1076.77,420.074 L 1081.41,429.543",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1072.9,432.477 L 1068.75,424.005",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1080.4,465.861 C 1082.63,466.958 1084.39,467.585 1087.25,470.993 L 1094.22,470.993 L 1094.22,448.821 L 1097.87,448.821 L 1097.87,443.611 L 1082.2,443.611 L 1082.2,448.821 L 1086.12,448.821 L 1086.12,463.353 L 1082.2,461.513 L 1080.4,465.861 Z",
    markerStart: "none",
    markerEnd: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbon);
export default __webpack_public_path__ + "static/media/ribbon.c86b8dc6ae12f226c56ec26da212187a.svg";
export { ForwardRef as ReactComponent };